module.exports = __webpack_public_path__ + "img/cyxm_list_bg.8d7c0679.png";